import { useCallback } from 'react';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { isNilOrEmpty } from 'ramda-extension';
import { useDispatch, useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components';
import CollapsibleTable from 'components/atoms/GefMui/CollapsibleTable';
import TableHasNoResults from 'components/atoms/GefMui/TableHasNoResults';
import codelistProvider from 'components/decorators/codelistProvider';
import { codelists } from 'constants/codelists';
import fetch from 'features/common/fetch';
import { subheaders } from 'features/common/Subheader/constants';
import { getVisibleStateById } from 'features/common/Subheader/selectors';
import { reloadInProgressLeads } from 'features/views/marketPlace/actions';
import {
	getInProgressAndAfterDeadlineLeadOverview,
	getSelectedInProgressTaskTypeId,
} from 'features/views/marketPlace/selectors';

import TableQuickFilters from './TableQuickFilters';
import TableRowInProgressAndAfterDeadline from './TableRowInProgressAndAfterDeadline';

const TableInProgressAndAfterDeadline = () => {
	const dispatch = useDispatch();
	const records = useSelector(getInProgressAndAfterDeadlineLeadOverview);
	const hasRecords = !isNilOrEmpty(records);
	const subheaderOpen = useSelector((state) => getVisibleStateById(state, subheaders.marketPlace, false));
	const selectedInProgressTaskTypeId = useSelector(getSelectedInProgressTaskTypeId);

	const handleReload = useCallback(() => {
		dispatch(reloadInProgressLeads());
	}, [dispatch]);

	return subheaderOpen ? (
		<TableQuickFilters />
	) : (
		<ComponentLoader
			fetchStorePath={`${fetch.constants.urls.leadsList}.inProgressAndAfterDeadline.${selectedInProgressTaskTypeId}`}
		>
			<ComponentLoader fetchStorePath={fetch.constants.urls.leadOverview} onReload={handleReload}>
				<CollapsibleTable
					tableId="MarketPlaceLeadsTable-inProgressAndDeadline"
					autoCloseOtherRows
					tableHeader={
						<TableHead>
							<TableRow>
								<TableCell width={65} />
								<TableCell width={250}>{getLabelMessage('marketPlace:opportunityType')}</TableCell>
								<TableCell width={1000} colSpan={5}>
									<div>{getLabelMessage('marketPlace:amount')}</div>
								</TableCell>
								<TableCell />
							</TableRow>
						</TableHead>
					}
					tableBody={
						!hasRecords ? (
							<TableHasNoResults />
						) : (
							records.map((record, id) => <TableRowInProgressAndAfterDeadline record={record} id={id} />)
						)
					}
				/>
			</ComponentLoader>
		</ComponentLoader>
	);
};

// initial fetch of finishTypes for later usage in rowInProgress
export default codelistProvider(codelists.finishTypes, 'finishTypesCodelist')(TableInProgressAndAfterDeadline);
